import { ReactNode, useEffect, useState } from 'react';

import { debounce } from 'lodash';

import { createGenericContext } from './generateContext';

const [useWindowSize, WindowSizeContextProvider] = createGenericContext<{
  windowSize: number | null;
}>();

const WindowSizeProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [windowSize, setWindowSize] = useState(0);

  useEffect(() => {
    function updateSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener('resize', debounce(updateSize, 200));
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <WindowSizeContextProvider
      value={{
        windowSize,
      }}
    >
      {children}
    </WindowSizeContextProvider>
  );
};
export { WindowSizeProvider, useWindowSize };
